export default __webpack_public_path__ + "static/media/incassi-dark.12415765.svg";